<template>
  <ul class="flex flex-row border-b border-gainsboro px-6">
    <router-link
      v-for="(item, index) in items"
      :key="index"
      :to="{name: item.link}"
      v-slot="{href, navigate, isActive}"
    >
      <li
        :class="[
          'link pb-3 mr-6 link text-trueBlue hover:text-black',
          isActive && 'active',
        ]"
      >
        <a :href="href" class="pb-3" @click="navigate">{{ item.name }}</a>
      </li>
    </router-link>
  </ul>
</template>

<script>
  export default {
    name: 'BaseNavigation',

    props: {
      items: {
        type: Array,
        default: () => [],
        required: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .link.active {
    color: black;
    border-bottom: 4px solid #0061D9;
  }
</style>
